import React, { ReactNode } from 'react'
import tw from 'twin.macro'
import LogoWhite from 'src/assets/images/gigsafe-logo-white.svg'
import { PartnersProfileButton } from '../header/PartnersProfileButton'

interface Props {
  children: ReactNode
}

export const CustomerOnboardingWrapper = ({ children }: Props) => {
  return (
    <div css={tw`h-full w-full flex flex-col`}>
      <div css={tw`bg-[#300258] w-full h-[60px] p-4 shadow flex justify-between items-center`}>
        <img src={LogoWhite} css={tw`h-[28px]`} />
        <div>
          <PartnersProfileButton logoutOnly />
        </div>
      </div>
      <div css={tw`w-full h-full flex flex-col overflow-y-scroll bg-[#F6F6F6]`}>
        <div css={tw`flex flex-1 flex-col items-center justify-center p-6 pb-20`}>{children}</div>
      </div>
    </div>
  )
}
